import React from "react";
import ReactDOM from "react-dom";

import MessageContainer from "../MessageContainer/MessageContainer";

import styles from "./Toast.module.css";
import { useTypedSelector } from "../../../redux/reducers/RootReducer";
import { selectToast } from "../../../redux/reducers/NotificationReducer";

const Toast = () => {
  const toast = useTypedSelector((state) => selectToast(state));

  return ReactDOM.createPortal(
    toast.open && (
      <div className={`${styles.container} ${toast.open && styles.open}`}>
        <MessageContainer message={toast.message} variant={toast.variant} />
      </div>
    ),
    document.getElementById("toast-root") as HTMLElement
  );
};

export default Toast;
